import React from "react"
import { Col, Row } from "react-bootstrap"
import FormatDate from "../../../../formatters/FormatDate"
import AccordionCard from "./AccordionCard"
import CardRow from "./CardRow"
import TestCardProps from "./TestCardProps"

export default function ExamResultDetailCard(props: TestCardProps) {
  const { data } = props
  const title = <Row>
    <Col xs={5} sm={3}>EXAM RESULT DETAIL</Col>
    <Col xs={3} sm={5}>{data.DateCollected ? data.CollectionStatusDescription : ""}</Col>
    <Col xs={4} sm={4}>{data.DateCollected ? FormatDate(data.DateCollected) : ""}</Col>
  </Row>
  return (
    <AccordionCard eventKey="examResultDetail" title={title}>
      <CardRow title="CERTIFICATION" value={data.TestDetailPhysicals.ExamResult}/>
      <CardRow title="EXPIRATION DATE" value={data.TestDetailPhysicals.ExpirationDate}/>
    </AccordionCard>
  )
}
